// extracted by mini-css-extract-plugin
module.exports = {"dropZone":"DropArea_dropZone__3-VCf","dropZone_active":"DropArea_dropZone_active__DO-CT"};